/* Show selected product option */
var firstOption = $(".product .swatch_options .swatch:first-child .option_title");
var firstOptionValue = firstOption.html();
var secondOption = $(".product .swatch_options .swatch:nth-child(2) .option_title");
var secondOptionValue= secondOption.html();
var thirdOption = $(".product .swatch_options .swatch:nth-child(3) .option_title");
var thirdOptionValue= thirdOption.html();

/*
 $('body').on("click",".product .swatch_options .swatch:first-child .swatch-element", function () {
   var variety1 = $(this).attr("data-value");
   $(".product .swatch_options .swatch:first-child .option_title").html("<strong>" + firstOptionValue + ":<span> " + variety1 + "</span></strong>");
 })
 $(".product .swatch_options .swatch:nth-child(2) .swatch-element").click( function () {
   var variety2 = $(this).attr("data-value")
   $(".product .swatch_options .swatch:nth-child(2) .option_title").html("<strong>" + secondOptionValue + ":<span> " + variety2 + "</span></strong>")
 })
$(".product .swatch_options .swatch:nth-child(3) .swatch-element").click( function () {
   var variety3 = $(this).attr("data-value")
   $(".product .swatch_options .swatch:nth-child(3) .option_title").html("<strong>" + thirdOptionValue + ":<span> " + variety3 + "</span></strong>")
 })
*/
$('body').on("click",".product .swatch_options .swatch .swatch-element", function () {
  var optionSize = $(this).attr("data-value");
  console.log(optionSize);
  $(this).closest('.swatch').find('.option_title span').remove();
  $(this).closest('.swatch').find('.option_title').append('<span>: '+optionSize+'</span>');
});

/* Filter accordion - collection pages */

jQuery(document).on('click','#filtercontrol',function() {
  /* jQuery('#filteraccordion').toggleClass('open'); */
  jQuery('.filter-group:nth-child(n+4)').slideToggle("slow","swing").toggleClass('open');
  return false;
});


/* Back to top */

function backToTop() {
  jQuery(function($) {
    var offset = 600;
    var duration = 500;
    $(window).scroll(function() {
      if ($(this).scrollTop() > offset) {
        $('.backtotop').fadeIn(duration);
      } 
      else {
        $('.backtotop').fadeOut(duration);
      }
    });
    
  });
}


jQuery(document).ready(backToTop);
jQuery(document).ajaxComplete(backToTop);
$(document).ready(function(){
  var $carousel = $('.product_gallery');
  $carousel.on( 'change.flickity', function( event, index ) {
    if($carousel.find('.gallery-cell.is-selected').find('.product-gallery__video[data-html5-video]').length){
//       console.log('is vid')
      $('.media-video').trigger('play'); 
    }
    else{
//       console.log('is img')
      $('.media-video').trigger('pause'); 
    }
  });
});